import type { ReactNode } from 'react'
import React from 'react'

import * as S from './styled'

type Props = {
  children: ReactNode
  hideScrollbar?: boolean
  fullWidth?: boolean
}

export const DashboardSectionScrollableContent = ({
  children,
  hideScrollbar = false,
  fullWidth = false,
}: Props) => {
  return (
    <S.Content $hideScrollbar={hideScrollbar} $fullWidth={fullWidth}>
      {children}
    </S.Content>
  )
}
